import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useUserStore } from "../../hooks/UseUserStore";
import { readLocalStorage } from "../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../types";
import { Role } from "../../types/roles/roleTypes";
import { ModalIntegration } from "./Modals/ModalIntegration";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'rut', label: 'Rut', align:'center' },
    { type: 'text', field: 'username', label: 'Username', align:'center' },
    // { type: 'text', field: 'privilege', label: 'privilegio', align:'center' },
];

export const IntegrationByUserView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionUser, getUsers, getUsersByCompany, deleteUser } = useUserStore();

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const role = userData?.userType || '';

    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getUsersApi()
    },[])

    const getUsersApi = async(search='') => {
        try {
            setLoading(true);
            const response = (role && role == Role.SUPER_ADMIN) ? await getUsers(search) : await getUsersByCompany(search);
            if(!response){
                setUsers([]); setLoading(false);
                return false;
            }else{
                setUsers(response);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onSelected = (rowSelected:any) => {
        setRowSelected(rowSelected);
        setShowModal(true)
    }


    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getUsersApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Integracion ERP de usuarios'}
                    columns={columns} 
                    loading={loading}
                    rows={users || []}
                    onRowClick={() => {}}
                    hasOptions
                    onSearch={onSearch}
                    onCustomAction={onSelected}
                    dense
                />
            </Grid>
            {
                showModal && 
                <ModalIntegration
                    open ={showModal}
                    closeModal={setShowModal}
                    userSelected={rowSelected}
                    listUser={getUsersApi} 
                    clearState={clearState}
                />
            }
        </>
    )
}